import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-link-two',
  templateUrl: './link-two.component.html',
  styleUrl: './link-two.component.css'
})
export class LinkTwoComponent {

}

